<template>
    <table class="customizable-card-table">
        <thead>
            <tr>
                <th v-if="showCardImages">
                    {{ $translate('card', 'Kreditkort') }}
                </th>
                <th 
                    v-for="(title, index) in tableTitles" 
                    :key="index"
                    class="col-text"
                >
                    {{ title }}
                </th>
                <th v-if="showOutLinks">
                    {{ $translate('application_label', 'Ansök') }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="(row, index) in tableData"
                :key="index"
                :class="{'d-none': hasHiddenRows && !showAll && index > initialVisibleCount}"
            >
                <td v-if="showCardImages">
                    <nuxt-link 
                        v-if="cards[index]" 
                        :to="$prismic.linkResolver(cards[index])" 
                        class="card-image-container"
                    >
                        <prismic-image :img="cards[index].data.image" w="120" />
                        <span>
                            {{ cards[index].data.title }}
                        </span>
                    </nuxt-link>
                </td>
                <td v-for="(column, columnIndex) in row" :key="columnIndex">
                    <div class="rich-text col-text" v-html="column" />
                </td>
                <td v-if="showOutLinks">
                    <ButtonTarget 
                        v-if="cards[index]" 
                        :link="cards[index]" 
                        background="orange"
                        size="sm" 
                        class="application-button"
                    />
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        cards: {
            type: Array,
            required: true
        },
        tableTitles: {
            type: Array,
            required: true
        },
        tableData: {
            type: Array,
            required: true
        },
        showCardImages: {
            type: Boolean,
            required: false,
            default: false
        },
        showOutLinks: {
            type: Boolean,
            required: false,
            default: false
        },
        hasHiddenRows: {
            type: Boolean,
            required: false,
            default: false
        },
        initialVisibleCount: {
            type: Number,
            required: true
        },
        showAll: {
            type: Boolean,
            required: false,
            default: true
        }
    }
};
</script>